import DVCore from "./core/DVCore";

const AdminUsersAPI = {};

AdminUsersAPI.baseURL = "/api/admin/users/";

const userURL = (username) =>
    AdminUsersAPI.baseURL + encodeURIComponent(username);

/**
 * Enrollment summary for a user, used to confirm the right person before a
 * reset. Available to admins and delegates.
 */
AdminUsersAPI.get2faStatus = (username, onSuccess, onFail, onError = null) =>
    DVCore.get(userURL(username) + "/2fa-status", null, onSuccess, onFail, onError);

/**
 * Clear a user's TOTP device, backup codes and outstanding SSO tickets.
 * `reason` is required for delegates, optional for admins.
 */
AdminUsersAPI.reset2fa = (username, reason, onSuccess, onFail, onError = null) =>
    DVCore.post(userURL(username) + "/reset-2fa", { reason },
                onSuccess, onFail, onError);

/** Admin only — users holding the 2FA-reset delegation. */
AdminUsersAPI.listDelegates = (onSuccess, onFail, onError = null) =>
    DVCore.get(AdminUsersAPI.baseURL + "delegates", null, onSuccess, onFail, onError);

AdminUsersAPI.grantDelegate = (username, note, onSuccess, onFail, onError = null) =>
    DVCore.post(userURL(username) + "/delegate", { note },
                onSuccess, onFail, onError);

AdminUsersAPI.revokeDelegate = (username, onSuccess, onFail, onError = null) =>
    DVCore.delete(userURL(username) + "/delegate", onSuccess, onFail, onError);

/** Admin only — substring search over username, email and names. */
AdminUsersAPI.search = (q, onSuccess, onFail, onError = null) =>
    DVCore.get(AdminUsersAPI.baseURL + "search", { q }, onSuccess, onFail, onError);

/** Admin only — full profile, 2FA state and recent 2FA events for one user. */
AdminUsersAPI.getInfo = (username, onSuccess, onFail, onError = null) =>
    DVCore.get(userURL(username) + "/info", null, onSuccess, onFail, onError);

/** Admin only — recent 2FA audit trail. */
AdminUsersAPI.listAudit = (params, onSuccess, onFail, onError = null) =>
    DVCore.get(AdminUsersAPI.baseURL + "2fa-audit", params || {},
               onSuccess, onFail, onError);

export default AdminUsersAPI;
